<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Lab Instrument Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${instrument_instance.name}`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit instrument instance'">
      <template #gated-content>
        <instrument-instance-form
          :instrument_instance="instrument_instance"
          @submit="submit"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import InstrumentInstanceForm from "@/components/lab/instrumentinstance/InstrumentInstanceForm";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { getModel } from "@/shared/fetch-utils";
import { instrumentInstanceNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";

const InstrumentInstanceRepository =
  LabRepositoryFactory.get("instrumentInstance");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "InstrumentInstanceEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    InstrumentInstanceForm,
    PermissionAlertGate,
  },
  data() {
    return {
      loading: true,
      instrument_instance_id: this.$route.params.instrument_instance_id || null,
      instrument_instance: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/instrument-instances",
            title: "Lab Instrument list",
          },
          {
            icon: "fa-eye",
            linkto: `/instrument-instances/${this.instrument_instance_id}`,
            title: "View instrument instance",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      const payload = { ...form_data };

      delete payload.id;
      delete payload.priority;

      try {
        await InstrumentInstanceRepository.update(
          this.instrument_instance_id,
          payload
        );

        this.editSuccess();

        this.$router.push(
          `/instrument-instances/${this.instrument_instance_id}`
        );
      } catch ({ response }) {
        const { data, status } = response;
        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Lab Instrument update Failed.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.instrument_instance = await getModel({
      model_type: "instrument_instance",
      id: this.instrument_instance_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: instrumentInstanceNotifications,
};
</script>
